module.exports = __webpack_public_path__ + "img/project-39.83db0333.png";